import { createActions } from 'redux-actions';


const actionCreators = createActions({
    APP: {
        ENV: {
            NODE: {
                SET: env => env,
            },
            OP: {
                SET: env => env,
            },
        },

        FEATURE_FLAGS: {
            SET: data => data,
            RESET: undefined,
        },

        SEARCH: {
            RESULTS: {
                SET: data => data,
                CLEAR: undefined,
            },

            ITEMS_PER_PAGE: {
                SET: (e, { value }) => value,
            },

            ACTIVE_PAGE: {
                SET: (e, { activePage }) => activePage,
            },

            SORT_BY: {
                SET: field => field,
            },
            ISLOADING: {
                SET: isLoading => isLoading,
            },
        },
        AFFILIATE_SELECTOR: {
            IS_OPEN: {
                SET: isOpen => isOpen,
            },
            SELECTED_ITEMS: {
                SET: selectedItems => selectedItems,
            },
            CONFIRMED_ITEMS: {
                SET: confirmedItems => confirmedItems,
            },
        },
        TYPES: {
            ORGANIZATION: {
                SET: data => data,
            },
        },
    },
});

export default actionCreators.app;
